export default __webpack_public_path__ + "static/media/corona.6681a61d.svg";